var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo-light",attrs:{"src":_vm.makeImageLink('YGFzfNpuR3oTw1-7UEM0CA', _vm.lightLogo, 'logo'),"alt":"Corporate Logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }